<template>
  <div class="radio-group" :class="{masque : this.display===true}">
    <div>
      <p class="titre">{{label}}</p>
      <div
    v-for="(item, index) in items"
      :key="index"
      :class="{ active: item.value == selected }"
      :for="index + '-radio-item'"
    >
      <input
        type="radio"
        :value="item.value"
        :id="index + '-radio-item'"
        v-model="selected"
        @change="handleRadio"
      />
      <p class="titre">{{ item.description }}</p>
    </div></div>
  </div>
</template>

<script>
export default {
props: {
    items: {
      type: Array,
      required: true,
    },
    label:{
        type:String
    },
    value: {
      required: false,
    },
    display:{
      type:Boolean,
      default:false
    },
  },
  data() {
    return {
      selected: this.value,
    };
  },
  methods: {
    handleRadio() {
      this.$emit("change", this.selected);
      this.$emit("input", this.selected);
     
    },
  },
}
</script>

<style scoped lang="scss">
.radio-group {
   margin:3px;
   display: inline;
  div{
    //display: flex;
    width: 100%;
    margin-left:2%;
    .titre{
      color: #8c9a9c;
      margin: 6px;
      font-size: 14px;
      display: inline;
      margin-left:3%;
    }
    div{
      width: 50%;
      display: flex;
    .titre{
      color: #8c9a9c;
      margin: 6px;
      font-size: 14px;
      display: inline;
    }
  }
  } 
}
.masque{
  display: none;
}
</style>